import axios from "axios";
import { getLoaderStore } from "./loaderBridge";

const http = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1/",
    headers: {
        "Content-Type": "application/json",
    },
});

http.interceptors.request.use(
    (config) => {
        // ⛔ skip global loader if explicitly disabled
        if (!config.skipGlobalLoader) {
            getLoaderStore()?.showLoader();
        }
        return config;
    },
    (error) => {
        getLoaderStore()?.hideLoader();
        return Promise.reject(error);
    }
);

http.interceptors.response.use(
    (response) => {
        if (!response.config.skipGlobalLoader) {
            getLoaderStore()?.hideLoader();
        }
        return response;
    },
    (error) => {
        if (!error.config?.skipGlobalLoader) {
            getLoaderStore()?.hideLoader();
        }
        return Promise.reject(error);
    }
);


// http.interceptors.request.use((config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
// });

export default http;

